import { Observable, Subject } from "rxjs";
import { localize, localizeToCase } from "@gtmhub/localization";
import { UiModalService } from "@webapp/ui/modal/services/modal.service";

type ConfirmDeleteItemOptions = { itemKey: string; itemToCase?: boolean; description?: string };

export const confirmDeleteItem = (modalService: UiModalService, options: ConfirmDeleteItemOptions): Observable<void> => {
  return confirmDelete(modalService, {
    title: localize("delete_x", { data: (options.itemToCase ? localizeToCase : localize)(options.itemKey) }),
    description: options.description,
  });
};

type ConfirmDeleteOptions = { title: string; description?: string };

export const confirmDelete = (modalService: UiModalService, options: ConfirmDeleteOptions): Observable<void> => {
  const subject = new Subject<void>();
  modalService.confirm({
    uiTitle: options.title,
    uiContent: options.description || localize("once_delete_can_not_be_undone"),
    uiIconType: null,
    uiOkText: localize("delete"),
    uiOkDanger: true,
    uiOnOk: () => {
      subject.next();
      subject.complete();
    },
    uiCancelText: localize("cancel"),
    uiOnCancel: () => {
      subject.complete();
    },
  });
  return subject;
};
